<template>
    <div>
        <span ref="label" v-if="!inEditMode" @mouseenter="showEditButton = true" @mouseleave="showEditButton = false">
            {{ value }}
            <v-btn v-if="showEditButton" class="edit-btn" fab x-small color="secondary" @click="onEdit">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </span>
        <v-form v-if="inEditMode" @submit="onSubmit">
            <v-text-field
                autofocus
                ref="inputfield"
                :hint="hint"
                v-model="displayedText"
                v-click-outside="onCancel"
                @keydown.esc="onCancel"
            ></v-text-field>
        </v-form>
    </div>
</template>

<script>
// TODO: commented out: copy styles to textfield
import Vue from 'vue'
import { ClickOutside } from 'vuetify/lib/directives'
// import { cloneDeep } from 'lodash'

export default Vue.extend({
    name: 'EditableLabel',
    directives: {
        ClickOutside,
    },
    props: {
        value: String,
        hint: String,
    },
    data: () => ({
        showEditButton: false,
        inEditMode: false,
        displayedText: '',
        // labelStyle: '',
    }),
    // mounted() {
    //     this.labelStyle = getComputedStyle(this.$refs.label).cssText
    // },
    // watch: {
    //     inEditMode(val) {
    //         val &&
    //             setTimeout(() =>
    //                 this.copyCSS(this.labelStyle, this.$refs.inputfield.$el, [
    //                     'font-family',
    //                     'font-weight',
    //                     'font-size',
    //                     'line-height',
    //                 ])
    //             )
    //     },
    // },
    methods: {
        onEdit() {
            this.displayedText = this.value
            this.inEditMode = true
        },
        onSubmit() {
            this.$emit('input', this.displayedText)
            this.inEditMode = false
        },
        onCancel() {
            this.inEditMode = false
        },
        // copyCSS(sourceStyle, toDOM, properties) {
        //     console.log(sourceStyle)
        //     const propList = sourceStyle
        //         .split(/;\s*/)
        //         .filter((item) => properties.includes(item.split(':')[0].replace('"', '')))
        //     console.log(propList)
        //     toDOM.style.cssText = propList.join(';')
        // },
    },
})
</script>

<style scoped>
.edit-btn {
    position: absolute;
    bottom: 0;
    right: -16px;
    opacity: 0.9;
}
</style>
